import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NotifierService } from "angular-notifier";
import { BehaviorSubject, Observable } from "rxjs";
import { LoginService } from "src/app/services/login.service";
import { ConsumerImmersionService } from "../../services/consumer-immersion.service";
import { MatDialog } from "@angular/material/dialog";
import { PoModalViewComponent } from "../po-modal-view/po-modal-view.component";
import { SidePanelService } from "src/app/shared/services/side-pannel/side-pannel.service";
import { ApiRequestService } from "src/app/services/api-request/api-request.service";

export class Credit{
    total:number = 0;
    locked:number= 0;
    isICVCreditFlow:number = 0;
}

export class Video{
    name:any;
    date:any;
    comment:any;
}

export class RequestDetails{
    title:string;
    request_owner:any;
    legal_name:any;
    language:any;
    interview:any = {
        pending:'',
        completed:'',
        approved:'',
        declined:''
    };
    requested_date:any;
    key_questions:any = [];
    preferred_interview_slots?:any=[];
    complete_date:any;
    target_audience:any = [];
    usership_criteria:any;
    comments:any;
    loi:any;
    video:Video[];
    fees_quote?:string;
    fees_quote_status?:string;
    fees_quote_accepted_by?:string;
    fees_quote_accepted_time?:string;
}


@Injectable({
    providedIn: 'root'
  })
export class RequestService{

    public requestList = [];
    public isICVVideoPlayerTagVisible:boolean = false;
    public requestCreadits:Credit;
    public todaysCreaditCount;
    public requestOwnerList = [];
    public filteredRequestOwnerList = [];
    public filteredCCUserList = [];
    public requestDetails:any = new RequestDetails();
    public autoCodeTitle = '';
    public playerURL = '';
    public playerAudioURL = '';
    public playerTitle = '';
    public playerAudioTitle = '';
    public isAddRequest:boolean = false;
    public isRequestCredit:boolean = false;
    public isPlayed:boolean = false;
    public isDialog:boolean = false;
    public accessRoles;
    public detailsID = '';
    public gender:any = [];
    public nccs:any = [];
    public isTncAccepted:boolean = false;
    public isAiDiscussionOpen:boolean = false;
    public aiDiscussionObjective:string = '';
    public isAddRequestCheck = new BehaviorSubject<boolean>(false);
    public poNum:string = "";
    public jobId:any='';
    public ci_uuid:any='';
    public ai_guide_list: any = [];
    public isProcessingAIrequest:boolean = false;
    
    public isCallingAlongWithAcceptAndApprove:boolean = false;
    public centerList = [
        "Patna", "Guwahati", "Bhubaneswar", "Kolkata", "Amritsar", "Lucknow", "Kanpur", 
        "Ludhiana", "Varanasi", "Chandigarh", "Agra", "Jaipur", "Allahabad", "Delhi", 
        "Noida", "Gurgaon", "Faridabad", "Vijayawada", "Coimbatore", "Madurai", "Vizag", 
        "Mysore", "Kochi", "Chennai", "Bangalore", "Hyderabad", "Mumbai", "Nagpur", 
        "Indore", "Bhopal", "Ahmedabad", "Vadodara", "Surat", "Pune", "Nasik"
    ];
    public minAgeContainer = [18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60];
    public copyCentreList = this.centerList;
    public isIcvDiscussionOpen: boolean = true;
    public isIcvDiscussionChatOpenMinView:boolean = false;
    public isIcvDiscussionChatOpenMaxView:boolean = false;
    public icvComment = '';

    constructor(private CIService:ConsumerImmersionService,
        private notifier: NotifierService,
        public sidePanelService:SidePanelService,
        private router:Router,
        public dialoge:MatDialog,
        private apiRequest: ApiRequestService,
        private logerror: LoginService){
            this.requestList = [];
            this.isICVVideoPlayerTagVisible = false;
            this.requestCreadits = new Credit();
            this.todaysCreaditCount = 0;
            this.autoCodeTitle = '';
            this.playerURL = '';
            this.playerAudioURL = '';
            this.playerTitle = '';
            this.playerAudioTitle = '';
            this.accessRoles = JSON.parse(localStorage.getItem('access'));
    }

    icvCommentViewCondition(){
        this.isIcvDiscussionOpen = false;
        this.isIcvDiscussionChatOpenMinView = true;
        this.isIcvDiscussionChatOpenMaxView = false;
    }

    getRequestList(){
        this.CIService.isLoading = true;
        this.CIService.getRequestList().subscribe((responce) => {
            if(responce['status'] == 1){
                this.requestList = responce['data'];
                if(!responce['data'].length){
                    this.isICVVideoPlayerTagVisible = true;
                    this.sidePanelService.isCIHighlighterShow = true;
                    this.sidePanelService.isSidePanelCIVideoHighlighterShow = false;
                    if(responce['credit'] && responce['credit'].isICVCreditFlow){
                        this.sidePanelService.IsICVCreditFloW = true;
                    }
                    // this.sidePanelService.initSideDrawer('ci');
                }else{
                    this.isICVVideoPlayerTagVisible = false;
                    this.sidePanelService.isCIHighlighterShow = true;
                    this.sidePanelService.isSidePanelCIVideoHighlighterShow = true;
                    if(responce['credit'] && responce['credit'].isICVCreditFlow){
                        this.sidePanelService.IsICVCreditFloW = true;
                    }
                    // this.sidePanelService.initSideDrawer('ci');

                }
                this.requestCreadits = responce['credit'];
                this.todaysCreaditCount = responce['today_count'];
            }else{
                this.notifier.notify('error','Something went wrong.');
            }
            this.CIService.isLoading = false;
        },error => {
            console.error(error['status'] == 401)
            if(error){
                this.notifier.notify('error','User is not authorised.');
                this.router.navigate(['homehome/access-denied']);
            }else{
                this.notifier.notify('error','Something went wrong.');
            }
            this.CIService.isLoading = false;
        });
    }

    getRequestDetails(uuid){
        this.CIService.isLoading = true;
        this.CIService.getRequestDetails(uuid).subscribe((responce) => {
            if(responce['status'] == 1){
                this.requestDetails = responce['data'];
                this.isAddRequest = this.router.url.includes('consumer-immersions/add-request');
                if(this.isAddRequest){
                    this.isAddRequestCheck.next(true);
                }
                if(this.requestDetails.misc && this.requestDetails.misc.discussion_guide){
                    this.ai_guide_list = [{discussion_guide: this.requestDetails.misc.discussion_guide, objective: this.requestDetails.objective, "selected": true, "request_uuid": uuid}];
                }
                this.jobId = this.requestDetails.job_id;
                this.ci_uuid = this.requestDetails.uuid;
                if(this.requestDetails.po){
                    this.poNum = this.requestDetails.po;
                }
            }else{
                this.notifier.notify('error','Something went wrong.');
            }
            this.CIService.isLoading = false;
        },error => {
            this.notifier.notify('error','Something went wrong.');
            this.CIService.isLoading = false;
        });
    }
    
    // createRequest(data){
    //     this.CIService.isLoading = true;
    //     data['ci_uuid'] = this.ci_uuid;
    //     // console.log("")
    //     let discussionGuide = this.ai_guide_list.find((item) => {return item && item.selected});
    //     if(discussionGuide){
    //         data['misc'] = {discussion_guide:discussionGuide["discussion_guide"]};
    //         data['objective'] = discussionGuide["objective"];
    //         // data['misc'] = {discussion_guide:discussionGuide["discussion_guide"], "uuid":discussionGuide["request_uuid"]};
    //     }
    //     this.CIService.createRequest(data).subscribe((responce) => {
    //         if(responce['status'] == 1){
    //             this.getRequestList();
    //             this.backToRequest(false);
    //             this.notifier.notify('success','Request sent successfully.');
    //         }else{
    //             this.notifier.notify('error',responce['errorMessage'] || 'Something went wrong.');
    //         }
    //         this.CIService.isLoading = false;
    //     },error => {
    //         this.notifier.notify('error','Something went wrong.');
    //         this.CIService.isLoading = false;
    //     });
    // }
    
    createRequest(data){
        this.CIService.isLoading = true;
        data['ci_uuid'] = this.ci_uuid;
        // console.log("")
        let discussionGuide = this.ai_guide_list.find((item) => {return item && item.selected});
        if(discussionGuide){
            data['misc'] = {discussion_guide:discussionGuide["discussion_guide"]};
            data['objective'] = discussionGuide["objective"];
            // data['misc'] = {discussion_guide:discussionGuide["discussion_guide"], "uuid":discussionGuide["request_uuid"]};
            this.CIService.createRequest(data).subscribe((responce) => {
                if(responce['status'] == 1){
                    this.getRequestList();
                    this.backToRequest(false);
                    this.notifier.notify('success','Request sent successfully.');
                }else{
                    this.notifier.notify('error',responce['errorMessage'] || 'Something went wrong.');
                }
                this.CIService.isLoading = false;
            },error => {
                this.notifier.notify('error','Something went wrong.');
                this.CIService.isLoading = false;
            });
        }else{
            this.autoGenerateAiDiscussionGuide(data,"createRequest");
        }
    }

    UpdateRequest(data){
        this.CIService.isLoading = true;
        let discussionGuide = this.ai_guide_list.find((item) => {return item && item.selected});
        console.log("discussionGuide ====> ", discussionGuide);
        if(discussionGuide){
            data['misc'] = {discussion_guide:discussionGuide["discussion_guide"]};
            data['objective'] = discussionGuide["objective"];
            this.CIService.updateRequest(data).subscribe((responce) => {
                if(responce['status'] == 1){
                    this.getRequestList();
                    this.backToRequest(true);
                    this.notifier.notify('success','Request updated successfully.');
                }else{
                    this.notifier.notify('error',responce['errorMessage'] || 'Something went wrong.');
                }
                this.CIService.isLoading = false;
            },error => {
                this.notifier.notify('error','Something went wrong.');
                this.CIService.isLoading = false;
            });
        }else{
            this.autoGenerateAiDiscussionGuide(data,"updateRequest");
        }
    }

    UpdateJobId(data){
        this.CIService.isLoading = true;
        this.CIService.updateRequest(data).subscribe((responce) => {
            if(responce['status'] == 1){
                this.getRequestDetails(data.uuid); 
                this.notifier.notify('success','Request updated successfully.');
            }else{
                this.notifier.notify('error','Something went wrong.');
            }
            this.CIService.isLoading = false;
        },error => {
            this.notifier.notify('error','Something went wrong.');
            this.CIService.isLoading = false;
        });
    }

    requestCredit(data){
        if(this.accessRoles.access_type != 'ci_manager'){
            this.CIService.isLoading = true;
            this.CIService.requestCredit(data).subscribe((responce) => {
                if(responce['status'] == 1){
                    this.close();
                    this.notifier.notify('success','Credit request sent successfully.');
                }else{
                    this.notifier.notify('error','Something went wrong.');
                }
                this.CIService.isLoading = false;
            },error => {
                this.notifier.notify('error','Something went wrong.');
                this.CIService.isLoading = false;
            });
        }else{
            this.notifier.notify('error','Not allowed to request credit.');
        }
    }

    getUsers(uuid,queryObj){
            if (this.accessRoles.access_rules && this.accessRoles.access_rules.user_management && this.accessRoles.access_rules.user_management.users && this.accessRoles.access_rules.user_management.users.user_roles) {
            
            let query = {
                isActiveUser : queryObj.isActiveUser,
                Admin:this.accessRoles.access_rules.user_management.users.user_roles.Admin,
                Manager:this.accessRoles.access_rules.user_management.users.user_roles.Manager,
                'Ci Admin':this.accessRoles.access_rules.user_management.users.user_roles['Ci Admin'],
                Ci_Admin:this.accessRoles.access_rules.user_management.users.user_roles.Ci_Admin,
                isPagination:false

              }
              if (queryObj.isOrgUser) {
                query['isOrgUser'] = queryObj.isOrgUser;
              }
              if (queryObj.org_uuid) {
                query['org_uuid'] = queryObj.org_uuid;
              }
            // if (!query.Admin && !query.Manager) {
            if (!query.Admin && !query.Manager && !query['Ci Admin'] && !query.Ci_Admin) {
                this.notifier.notify('error','User is not authorised.');
                console.error("insise error");
                return;
            }else{
                this.getRequestOwnerList(uuid,query)
            }
        }else{
            this.notifier.notify('error','User is not authorised.');
            console.error("insise error");
        }
        
    }

    getRequestOwnerList(uuid,query){
        this.CIService.isLoading = true;
        this.CIService.getRequestOwnerList(uuid,query).subscribe((responce) => {
            if(responce['status'] == 1){
                this.requestOwnerList = responce['users'];
                if(this.requestOwnerList.length == 0){
                    this.notifier.notify('info','No request owners.');
                }
            }else{
                this.notifier.notify('error', responce['message']);
                this.requestOwnerList = [];
            }

            this.filteredRequestOwnerList = JSON.parse(JSON.stringify(this.requestOwnerList))
            this.filteredCCUserList = JSON.parse(JSON.stringify(this.requestOwnerList))
            this.CIService.isLoading = false;
        },error => {
            this.notifier.notify('error','Something went wrong.');
            this.CIService.isLoading = false;
        });
    }

    getVideoAudioUrl(){
        this.CIService.isLoading = true;
        this.CIService.getVideoAudioUrl(this.playerTitle).subscribe((responce) => {
            if(responce['status'] == 1){
                this.playerURL = responce['url'];
                this.isPlayed = true;
                this.CIService.isLoading = false;
                this.router.navigate(['consumer-immersions/video-player']);
            }else{
                this.notifier.notify('error', responce['message']);
                this.requestOwnerList = [];
                this.filteredRequestOwnerList = [];
                this.filteredCCUserList = [];
                this.CIService.isLoading = false;
            }
        },error => {
            this.notifier.notify('error','Something went wrong.');
        });
        
        this.CIService.getVideoAudioUrl(this.playerAudioTitle).subscribe((responce) => {
            if(responce['status'] == 1){
                this.playerAudioURL = responce['url'];
            }else{
                this.notifier.notify('error', responce['message']);
                this.requestOwnerList = [];
                this.filteredRequestOwnerList = [];
                this.filteredCCUserList = [];
            }
            this.CIService.isLoading = false;
        },error => {
            this.notifier.notify('error','Something went wrong.');
            this.CIService.isLoading = false;
        });
    }

    switchAddRequest(){
        let date:any = new Date();
        let org = JSON.parse(localStorage.getItem('access'))['org_name'].substring(0,3);
        date = date.getDate() +""+ (date.getMonth() + 1) +""+ date.getFullYear();
        this.autoCodeTitle = org + date + this.todaysCreaditCount;
        this.isRequestCredit = false;
        this.isAddRequest = true;
        if(this.requestCreadits.isICVCreditFlow){
            if(this.requestCreadits.total > 0){
                this.router.navigate(['consumer-immersions/add-request']);
            }else{
                this.isAddRequest = false;
                this.notifier.notify('error','No credits available.');
            }
        }else{
            this.router.navigate(['consumer-immersions/add-request']);
        }
    }
    
    switchRequestCredit(){
        this.isAddRequest = false;
        if(this.accessRoles.access_type != 'ci_manager'){
            this.isRequestCredit = true;
        }else{
            this.notifier.notify('error','Not allowed to request credit.');
        }
    }

    close(){
        this.isAddRequest = false;
        this.isRequestCredit = false;
        this.sidePanelService.IsICVCreditFloW = false;
    }

    backToRequest(isUpdate){
        this.isAddRequest = false;
        this.isRequestCredit = false;
        if(isUpdate){
            let uuid:any = this.router.url.split('/');
            uuid = uuid[uuid.length-1];
            this.router.navigate(['consumer-immersions/request-list/request-details/', uuid]);
        }else{
            this.router.navigate(['consumer-immersions/request-list']);
        }
    }

    openAiDiscussion(){
        this.isAiDiscussionOpen = true;
    }

    closeAiDiscussion(){
        this.isAiDiscussionOpen = false;
    }

    openPlayer(title){
        title = JSON.parse(title);
        title.forEach(element => {
            if(element.includes('.MP4')){
                this.playerTitle = element;
            }else{
                this.playerAudioTitle = element;
            }
        });
        setTimeout(()=>{
            this.getVideoAudioUrl();
        }, 550);
    }

    closePlayer(){
        this.isPlayed = false;
        if(this.detailsID != ''){
            this.router.navigate(['consumer-immersions/request-list/request-details',this.detailsID]);
        }else{
            this.router.navigate(['consumer-immersions/request-list']);
        }
        this.playerTitle = '';
        this.playerURL = '';
    }

    getDropdownValues(){
        this.CIService.isLoading = true;
        this.CIService.getDropdownValues().subscribe((responce) => {
            if(responce['status'] == 1){
                this.gender = responce['result']['gender'];
                this.nccs = responce['result']['NCCS'];
            }else{
                this.notifier.notify('error', responce['message']);
                this.gender = [];
                this.nccs = [];
            }
            this.CIService.isLoading = false;
        },error => {
            this.notifier.notify('error','Something went wrong.');
            this.CIService.isLoading = false;
        });
    }

    sanctionRequest(uuid){
        this.CIService.isLoading = true;
        this.CIService.sanctionRequest(uuid).subscribe((responce) => {
            if(responce['status'] == 1){
                this.notifier.notify('success', 'Request Approved & sent to Ipsos.');
                this.getRequestDetails(uuid);
            }else{
                this.notifier.notify('error', responce['message']);
            }
            this.CIService.isLoading = false;
        },error => {
            this.notifier.notify('error','Something went wrong.');
            this.CIService.isLoading = false;
        });
    }

    openPoModal(callType){
        this.isCallingAlongWithAcceptAndApprove = callType;
        this.dialoge.open(PoModalViewComponent,{
            height:'300px',
            width:'400px'
        })
    }

    onAcceptAndProve(uuid,status){
        if(this.isTncAccepted){
            this.openPoModal(true);
        }else{
            this.notifier.notify('error','Please scroll to read and accept the Project terms');
        }
    }

    onApprove(uuid,status){
        let query = {"uuid":uuid,"status":status};
        this.CIService.onRequestQuoteApprove(query).subscribe((responce) => {
            if(responce['status'] == 1){
                this.notifier.notify('success', 'Request Approved.');
                this.getRequestDetails(uuid);
            }else{
                this.notifier.notify('error', responce['message']);
            }
            console.log("===> "+responce['message'])
            this.CIService.isLoading = false;
        },error => {
            this.notifier.notify('error','Something went wrong.');
            this.CIService.isLoading = false;
        });      
    }

    poNumSubmit(){
        this.CIService.updatePONumberRequest(this.requestDetails.uuid,this.requestDetails.request_owner_uuid,this.poNum)
        .subscribe((response) => {
            if(response['status'] == 1){
                if(this.isCallingAlongWithAcceptAndApprove){
                    this.onApprove(this.requestDetails.uuid,'approve');
                }else{
                    this.notifier.notify('success',response['message']);
                    this.requestDetails.po = this.poNum;
                }
            }else{
                this.notifier.notify('error', response['message']);
            }
        },error => {
            this.notifier.notify('error','Something went wrong.');
        });
        this.dialoge.closeAll();
    }

    onSkipPoNum(){
        this.dialoge.closeAll();
        if(this.isCallingAlongWithAcceptAndApprove){
            this.onApprove(this.requestDetails.uuid,'approve');
        }else{
            this.poNum = this.requestDetails.po || "";
        }
    }

    copyFinalQuotation(){
        if(navigator){
            navigator.clipboard.writeText(this.requestDetails['fees_quote'])
            this.notifier.notify('success','Copied');
        }

    }

    generateAiDiscussionGuide(body){
        this.CIService.isLoading = true;
        this.isProcessingAIrequest = true;
        this.createAiDiscussionGuide(body).subscribe((responce) => {
            if(responce['status'] == 1){
                this.setAiDiscussionGuideList(responce['data']);
                // this.notifier.notify('success',responce['message']);
            }else{
                this.notifier.notify('error',responce['errorMessage'] || 'Something went wrong.');
            }
            this.CIService.isLoading = false;
            this.isProcessingAIrequest = false;
        },error => {
            this.notifier.notify('error','Something went wrong.');
            this.CIService.isLoading = false;
            this.isProcessingAIrequest = false;
        });
    }

    
    autoGenerateAiDiscussionGuide(data,method){
        this.CIService.isLoading = true;
        let body = {
            "objective": data.objective,
            "ci_uuid": this.ci_uuid,
            "job_id": this.jobId
        };
        this.isProcessingAIrequest = true;
        this.createAiDiscussionGuide(body).subscribe((responce) => {
            if(responce['status'] == 1){
                this.setAiDiscussionGuideList(responce['data']);
                if(method === "createRequest"){
                    this.createRequest(data);
                }else if(method === "updateRequest"){
                    this.UpdateRequest(data);
                }
            }else{
                this.notifier.notify('error',responce['errorMessage'] || 'Something went wrong.');
            }
            this.CIService.isLoading = false;
            this.isProcessingAIrequest = false;
        },error => {
            this.notifier.notify('error','Something went wrong.');
            this.CIService.isLoading = false;
            this.isProcessingAIrequest = false;
        });
    }

    setAiDiscussionGuideList(data){
        this.ai_guide_list.push(data);
        if(this.ai_guide_list.length == 1){
            this.ai_guide_list[0].selected = true;
        }
        setTimeout(() => {
            this.scrollToTargetID('ai-discussion-objective-'+(this.ai_guide_list.length - 1));
        }, 100);
        // this.scrollToTargetID('ai-discussion-guide-'+(this.ai_guide_list.length - 1));
    }

    scrollToTargetID(targetId: string) {
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    }


    createAiDiscussionGuide(body):Observable<any>{
        return this.apiRequest.request('POST',"/v2/ci/objective",body);
    }

    updateInterviewAiDiscussionGuide(body):Observable<any>{
        return this.apiRequest.request('PUT',"/v2/ci/interview-guide",body);
    }

    getAiDiscussionGuide(uuid):Observable<any>{
        return this.apiRequest.request('GET', '/v2/ci/interview-guide/' + uuid);
    }
    clearAiDiscussionGuide(){
        this.ai_guide_list = [];
        this.isAiDiscussionOpen = false;
        this.aiDiscussionObjective = '';
    }

}